/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import AppDispatcher from '../../core/AppDispatcher'
import ApiClient from '../../ApiClient'
import LoginApi from '../../api/LoginApi'
import AutoActionApi from '../../api/AutoActionApi'
import ApiHandle from '../../util/ApiHandle'
import history from '../../util/history'
import { appActions } from '../AppActions'

export const AutoTaskActionTypes = {
  fetchRooms: 'auto_action/tasks/fetch-room',
  fetchSiteReferrers: 'auto_action/tasks/fetchSiteReferrers',
  fetchOne: 'auto_action/tasks/fetch-one',
  fetchAll: 'auto_action/tasks/fetch-all',
  onCreate: 'auto_action/tasks/on-create',
  onEdit: 'auto_action/tasks/on-edit'
}

const loginApi = new LoginApi(ApiClient.instance)
const autoActionApi = new AutoActionApi(ApiClient.instance)

const AutoTaskActions = {
  fetchRooms: () => {
    const apiHandleOpts = {
      apiCall: () => loginApi.getUserRooms(),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(AutoTaskActionTypes.fetchRooms, { rooms: response })
      },
      onErrored: error => {
        appActions.snackbar('宿情報の取得に失敗しました', 'error', true)
      }
    }
    ApiHandle(apiHandleOpts)
  },
  fetchSiteReferrers: type => {
    const apiHandleOpts = {
      apiCall: () => loginApi.getSiteReferrers({ site_referrers: { available_type: type } }),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(AutoTaskActionTypes.fetchSiteReferrers, { site_referrers: response })
      },
      onErrored: () => {
        appActions.snackbar('OTA情報の取得に失敗しました', 'error', true)
      }
    }
    ApiHandle(apiHandleOpts)
  },
  fetchOne: id => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.getAutoActionTask(id),
      onSucceded: response => AppDispatcher.dispatchWithType(AutoTaskActionTypes.fetchOne, response),
      onFailed: response => {},
      onErrored: error => {}
    }
    ApiHandle(apiHandleOpts)
  },

  fetchAll: () => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.getAutoActionTasks(),
      onSucceded: response => AppDispatcher.dispatchWithType(AutoTaskActionTypes.fetchAll, { tasks: response }),
      onFailed: response => {},
      onErrored: error => {}
    }
    ApiHandle(apiHandleOpts)
  },

  onCreate: () => {
    AppDispatcher.dispatchWithType(AutoTaskActionTypes.onCreate)
    history.push(`/auto_action/tasks/new`)
  },

  onCreateWithCopy: async id => {
    const response = await autoActionApi.getAutoActionTask(id).catch(e => e)
    if (response instanceof Error) {
      appActions.showAlert(response, 'コピーに失敗しました')
      return
    }

    AppDispatcher.dispatchWithType(AutoTaskActionTypes.fetchOne, response)

    history.push(`/auto_action/tasks/new`)
  },

  onUpdate: auto_action_task => {
    history.push(`/auto_action/tasks/${auto_action_task.id}/edit`)
  },

  onEdit: e => {
    AppDispatcher.dispatchWithType(AutoTaskActionTypes.onEdit, { name: e.target.name, value: e.target.value })
  },

  onCancel: () => {
    history.push(`/auto_action/tasks`)
  },

  onRequestCreate: autoTaskState => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.newAutoActionTask(autoTaskState.getApiParameters()),
      onSucceded: response => {
        AutoTaskActions.onCancel()
        appActions.snackbar('追加しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '登録に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestUpdate: autoTaskState => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.updateAutoActionTask(autoTaskState.auto_action_task_id, autoTaskState.getApiParameters()),
      onSucceded: response => {
        AutoTaskActions.onCancel()
        appActions.snackbar('更新しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '更新に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestDelete: id => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.deleteAutoActionTask(id),
      onSucceded: response => {
        AutoTaskActions.onCancel()
        appActions.snackbar('削除しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '削除に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  }
}

export default AutoTaskActions
